import React, { useState } from "react";
import imageCompression from "browser-image-compression";

const ImageUploader = ({ onChange, imageFile,
    setImageFile, previewUrl, ingredientImageFile, setIngredientImageFile, ingredientPreviewUrl, setIngredientPreviewUrl,
    setPreviewUrl, imageFor = 'product' }) => {
    const [error, setError] = useState(null);
    const [isCompressing, setIsCompressing] = useState(false);




    const allowedFileTypes = [
        "image/png",
        "image/jpeg",
        "image/svg+xml",
        "image/gif",
        "image/vnd.microsoft.icon",
        "image/x-icon",
    ];

    const maxSizeMB = 2;

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        setError(null);

        if (!file) return;

        if (!allowedFileTypes.includes(file.type)) {
            setError("Unsupported file type. Please select a valid image.");
            return;
        }

        setIsCompressing(true);

        try {
            const options = {
                maxSizeMB: maxSizeMB,
                maxWidthOrHeight: 1920,
                useWebWorker: true,
            };

            const compressedFile = await imageCompression(file, options);

            if (compressedFile.size / 1024 / 1024 > maxSizeMB) {
                setError("File is too large even after compression. Must be under 2MB.");
                setIsCompressing(false);
                return;
            }

            const preview = URL.createObjectURL(compressedFile);


            if (imageFor === 'ingredients-image') {
                setIngredientImageFile(compressedFile)
                setIngredientPreviewUrl(preview)

            } else {
                setImageFile(compressedFile);
                setPreviewUrl(preview);

            }

            onChange && onChange(compressedFile);
        } catch (err) {
            console.error("Compression error:", err);
            setError("Something went wrong during image processing.");
        } finally {
            setIsCompressing(false);
        }
    };

    const handleRemove = () => {

        if (imageFor === 'ingredients-image') {
            setIngredientImageFile('')
            setIngredientPreviewUrl('')

        } else {
            setImageFile(null);
            setPreviewUrl(null);

        }

        setError(null);
        setIsCompressing(false);
        onChange && onChange(null);
    };

    return (
        <>
            {isCompressing && (
                <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
                    <div className="loader" />
                    <span style={{ color: "#007bff" }}>Compressing image…</span>
                </div>
            )}

            {(imageFor === 'ingredients-image' ? ingredientPreviewUrl : previewUrl) ? (
                <div style={{ position: "relative", display: "inline-block" }}>
                    <img
                        src={imageFor === 'ingredients-image' ? ingredientPreviewUrl : previewUrl}
                        alt="Preview"
                        style={{
                            marginTop: '25px',
                            width: 200,
                            height: 200,
                            objectFit: "cover",
                            borderRadius: 8,
                            border: "1px solid white",
                            opacity: isCompressing ? 0.4 : 1,
                            transition: "opacity 0.3s",
                        }}
                    />
                    {!isCompressing && (
                        <button
                            onClick={handleRemove}
                            style={{
                                position: "absolute",
                                top: -33,
                                right: -15,
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: 24,
                                height: 24,
                                cursor: "pointer",
                            }}
                            title="Remove"
                        >
                            ×
                        </button>
                    )}
                </div>
            ) : (
                <>
                    <label
                        style={{
                            display: "flex",
                            marginTop: '20px',
                            padding: "20px",
                            background: imageFor === 'ingredients-image' ? "gray" : "#007bff",
                            color: "#fff",
                            borderRadius: 5,
                            cursor: "pointer",
                            opacity: isCompressing ? 0.6 : 1,
                            width: imageFor === 'ingredients-image' ? '140px ' : '120px',
                            height: imageFor === 'ingredients-image' ? '40px ' : '20px',
                            pointerEvents: isCompressing ? "none" : "auto",
                        }}
                    >
                        {imageFor === 'ingredients-image' ? 'Browse ingredients image' : 'Browse Image'}
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            style={{ display: "none", }}
                        />
                    </label>

                    <div style={{ marginTop: '10px', color: 'gray' }}>
                        {imageFor === 'ingredients-image' ? 'Upload ingredients image' : 'Upload Product Image'}
                    </div>
                </>

            )}

            {error && (
                <div style={{ color: "red", marginTop: "0.5rem", fontSize: 14 }}>{error}</div>
            )}

            {/* Spinner CSS */}
            <style>{`
        .loader {
          border: 3px solid #f3f3f3;
          border-top: 3px solid #007bff;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          animation: spin 0.8s linear infinite;
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
        </>
    );
};

export default ImageUploader;